import { SHORT_LIST_INIT } from "redux/actionTypes/shorts.ActionTypes";

export const saveShortList = (payload) => {
  return { type: SHORT_LIST_INIT, payload };
};
